import React from "react";
import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import Typography from "ui/Typography";

const FormHeader = (props) => {
  const { title, subTitle } = props;

  const style = {
    display: "flex",
    padding: "24px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "2px",
    alignSelf: "stretch",
  };

  return (
    <Stack sx={style}>
      <Typography variant="h5">{title}</Typography>
      {subTitle && <Typography variant="body1">{subTitle}</Typography>}
    </Stack>
  );
};

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
};

export default FormHeader;
